import _objectSpread from "/var/www/html/codexrnew/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/var/www/html/codexrnew/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/var/www/html/codexrnew/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject88() {
  var data = _taggedTemplateLiteral(["\n  backface-visibility: hidden;\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  transform-style: preserve-3d;\n  transform: translate3d(0, 0, 0);\n  width: 100%;\n\n  ", ";\n"]);

  _templateObject88 = function _templateObject88() {
    return data;
  };

  return data;
}

function _templateObject87() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  perspective: 1200px;\n  overflow: hidden;\n"]);

  _templateObject87 = function _templateObject87() {
    return data;
  };

  return data;
}

function _templateObject86() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n    "]);

  _templateObject86 = function _templateObject86() {
    return data;
  };

  return data;
}

function _templateObject85() {
  var data = _taggedTemplateLiteral(["\n      ", ";\n    "]);

  _templateObject85 = function _templateObject85() {
    return data;
  };

  return data;
}

function _templateObject84() {
  var data = _taggedTemplateLiteral(["\n      z-index: 1;\n    "]);

  _templateObject84 = function _templateObject84() {
    return data;
  };

  return data;
}

function _templateObject83() {
  var data = _taggedTemplateLiteral(["\n  animation-name: ", ";\n  animation-delay: ", ";\n  animation-duration: ", "ms;\n  animation-timing-function: ", ";\n  animation-fill-mode: ", ";\n  transform-origin: ", ";\n\n  ", "\n"]);

  _templateObject83 = function _templateObject83() {
    return data;
  };

  return data;
}

function _templateObject82() {
  var data = _taggedTemplateLiteral(["\n      0%, 25% { opacity: 0.5; transform: translateZ(-500px) translateX(200%); }\n      75% { opacity: 0.5; transform: translateZ(-500px); }\n      100% { opacity: 1; transform: translateZ(0) translateX(0); }\n    "]);

  _templateObject82 = function _templateObject82() {
    return data;
  };

  return data;
}

function _templateObject81() {
  var data = _taggedTemplateLiteral(["\n      0% { }\n      25% { opacity: 0.5; transform: translateZ(-500px); }\n      75% { opacity: 0.5; transform: translateZ(-500px) translateX(-200%); }\n      100% { opacity: 0.5; transform: translateZ(-500px) translateX(-200%); }\n    "]);

  _templateObject81 = function _templateObject81() {
    return data;
  };

  return data;
}

function _templateObject80() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: translateZ(-500px) rotateY(-90deg); }\n    "]);

  _templateObject80 = function _templateObject80() {
    return data;
  };

  return data;
}

function _templateObject79() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: translateZ(-500px) rotateY(90deg); }\n    "]);

  _templateObject79 = function _templateObject79() {
    return data;
  };

  return data;
}

function _templateObject78() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateY(-200%) scale(0.4) rotateX(65deg); }\n    "]);

  _templateObject78 = function _templateObject78() {
    return data;
  };

  return data;
}

function _templateObject77() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateY(200%) scale(0.4) rotateX(-65deg); }\n    "]);

  _templateObject77 = function _templateObject77() {
    return data;
  };

  return data;
}

function _templateObject76() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateY(200%) scale(0.4) rotateX(-65deg); }\n    "]);

  _templateObject76 = function _templateObject76() {
    return data;
  };

  return data;
}

function _templateObject75() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateY(-200%) scale(0.4) rotateX(65deg); }\n    "]);

  _templateObject75 = function _templateObject75() {
    return data;
  };

  return data;
}

function _templateObject74() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateX(-200%) scale(0.4) rotateY(-65deg); }\n    "]);

  _templateObject74 = function _templateObject74() {
    return data;
  };

  return data;
}

function _templateObject73() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateX(200%) scale(0.4) rotateY(65deg); }\n    "]);

  _templateObject73 = function _templateObject73() {
    return data;
  };

  return data;
}

function _templateObject72() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateX(200%) scale(0.4) rotateY(65deg); }\n    "]);

  _templateObject72 = function _templateObject72() {
    return data;
  };

  return data;
}

function _templateObject71() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateX(-150%) scale(0.4) rotateY(-65deg); }\n    "]);

  _templateObject71 = function _templateObject71() {
    return data;
  };

  return data;
}

function _templateObject70() {
  var data = _taggedTemplateLiteral(["\n      0% { opacity: 0.3; -webkit-transform: translateY(-100%) rotateX(90deg); transform: translateY(-100%) rotateX(90deg); }\n      50% { animation-timing-function: ease-out; transform: translateY(-50%) translateZ(-200px) rotateX(45deg); }\n    "]);

  _templateObject70 = function _templateObject70() {
    return data;
  };

  return data;
}

function _templateObject69() {
  var data = _taggedTemplateLiteral(["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateY(50%) translateZ(-200px) rotateX(-45deg); }\n      100% { opacity: 0.3; -webkit-transform: translateY(100%) rotateX(-90deg); transform: translateY(100%) rotateX(-90deg); }\n    "]);

  _templateObject69 = function _templateObject69() {
    return data;
  };

  return data;
}

function _templateObject68() {
  var data = _taggedTemplateLiteral(["\n      0% { opacity: 0.3; transform: translateY(100%) rotateX(-90deg); }\n      50% { animation-timing-function: ease-out; transform: translateY(50%) translateZ(-200px) rotateX(-45deg); }\n    "]);

  _templateObject68 = function _templateObject68() {
    return data;
  };

  return data;
}

function _templateObject67() {
  var data = _taggedTemplateLiteral(["\n      0% {}\n      50% { animation-timing-function: ease-out; transform: translateY(-50%) translateZ(-200px) rotateX(45deg); }\n      100% { opacity: 0.3; transform: translateY(-100%) rotateX(90deg); }\n    "]);

  _templateObject67 = function _templateObject67() {
    return data;
  };

  return data;
}

function _templateObject66() {
  var data = _taggedTemplateLiteral(["\n      0% { opacity: 0.3; transform: translateX(-100%) rotateY(-90deg); }\n      50% { animation-timing-function: ease-out; transform: translateX(-50%) translateZ(-200px) rotateY(-45deg); }\n    "]);

  _templateObject66 = function _templateObject66() {
    return data;
  };

  return data;
}

function _templateObject65() {
  var data = _taggedTemplateLiteral(["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateX(50%) translateZ(-200px) rotateY(45deg); }\n      100% { opacity: 0.3; transform: translateX(100%) rotateY(90deg); }\n    "]);

  _templateObject65 = function _templateObject65() {
    return data;
  };

  return data;
}

function _templateObject64() {
  var data = _taggedTemplateLiteral(["\n      0% { opacity: 0.3; transform: translateX(100%) rotateY(90deg); }\n      50% { animation-timing-function: ease-out; transform: translateX(50%) translateZ(-200px) rotateY(45deg); }\n    "]);

  _templateObject64 = function _templateObject64() {
    return data;
  };

  return data;
}

function _templateObject63() {
  var data = _taggedTemplateLiteral(["\n      0% { }\n      50% { animation-timing-function: ease-out; transform: translateX(-50%) translateZ(-200px) rotateY(-45deg); }\n      100% { opacity: 0.3; transform: translateX(-100%) rotateY(-90deg); }\n    "]);

  _templateObject63 = function _templateObject63() {
    return data;
  };

  return data;
}

function _templateObject62() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateY(-100%) rotateX(-90deg); }\n    "]);

  _templateObject62 = function _templateObject62() {
    return data;
  };

  return data;
}

function _templateObject61() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateY(100%) rotateX(90deg); }\n    "]);

  _templateObject61 = function _templateObject61() {
    return data;
  };

  return data;
}

function _templateObject60() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateY(100%) rotateX(90deg); }\n    "]);

  _templateObject60 = function _templateObject60() {
    return data;
  };

  return data;
}

function _templateObject59() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateY(-100%) rotateX(-90deg); }\n    "]);

  _templateObject59 = function _templateObject59() {
    return data;
  };

  return data;
}

function _templateObject58() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateX(-100%) rotateY(90deg); }\n    "]);

  _templateObject58 = function _templateObject58() {
    return data;
  };

  return data;
}

function _templateObject57() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateX(100%) rotateY(-90deg); }\n    "]);

  _templateObject57 = function _templateObject57() {
    return data;
  };

  return data;
}

function _templateObject56() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateX(100%) rotateY(-90deg); }\n    "]);

  _templateObject56 = function _templateObject56() {
    return data;
  };

  return data;
}

function _templateObject55() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateX(-100%) rotateY(90deg); }\n    "]);

  _templateObject55 = function _templateObject55() {
    return data;
  };

  return data;
}

function _templateObject54() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: translateY(100%) rotateX(-90deg); }\n    "]);

  _templateObject54 = function _templateObject54() {
    return data;
  };

  return data;
}

function _templateObject53() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: translateY(-100%) rotateX(90deg); }\n    "]);

  _templateObject53 = function _templateObject53() {
    return data;
  };

  return data;
}

function _templateObject52() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0;  transform: translateX(100%) rotateY(90deg); }\n    "]);

  _templateObject52 = function _templateObject52() {
    return data;
  };

  return data;
}

function _templateObject51() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: translateX(-100%) rotateY(-90deg); }\n    "]);

  _templateObject51 = function _templateObject51() {
    return data;
  };

  return data;
}

function _templateObject50() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: translateY(100%) rotateX(-90deg); }\n    "]);

  _templateObject50 = function _templateObject50() {
    return data;
  };

  return data;
}

function _templateObject49() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: translateY(-100%) rotateX(90deg); }\n    "]);

  _templateObject49 = function _templateObject49() {
    return data;
  };

  return data;
}

function _templateObject48() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: translateX(-100%) rotateY(-90deg); }\n    "]);

  _templateObject48 = function _templateObject48() {
    return data;
  };

  return data;
}

function _templateObject47() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: translateX(100%) rotateY(90deg); }\n    "]);

  _templateObject47 = function _templateObject47() {
    return data;
  };

  return data;
}

function _templateObject46() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: rotateX(90deg); }\n    "]);

  _templateObject46 = function _templateObject46() {
    return data;
  };

  return data;
}

function _templateObject45() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: rotateX(-90deg); }\n    "]);

  _templateObject45 = function _templateObject45() {
    return data;
  };

  return data;
}

function _templateObject44() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: rotateY(90deg); }\n    "]);

  _templateObject44 = function _templateObject44() {
    return data;
  };

  return data;
}

function _templateObject43() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: rotateY(-90deg); }\n    "]);

  _templateObject43 = function _templateObject43() {
    return data;
  };

  return data;
}

function _templateObject42() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: rotateX(90deg); }\n    "]);

  _templateObject42 = function _templateObject42() {
    return data;
  };

  return data;
}

function _templateObject41() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: rotateX(-90deg); }\n    "]);

  _templateObject41 = function _templateObject41() {
    return data;
  };

  return data;
}

function _templateObject40() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: rotateY(-90deg); }\n    "]);

  _templateObject40 = function _templateObject40() {
    return data;
  };

  return data;
}

function _templateObject39() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: rotateY(90deg); }\n    "]);

  _templateObject39 = function _templateObject39() {
    return data;
  };

  return data;
}

function _templateObject38() {
  var data = _taggedTemplateLiteral(["\n      from { transform: translateZ(-3000px) rotateZ(-360deg); opacity: 0; }\n    "]);

  _templateObject38 = function _templateObject38() {
    return data;
  };

  return data;
}

function _templateObject37() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateZ(-3000px) rotateZ(360deg); opacity: 0; }\n    "]);

  _templateObject37 = function _templateObject37() {
    return data;
  };

  return data;
}

function _templateObject36() {
  var data = _taggedTemplateLiteral(["\n      0% { transform: rotateZ(0deg); }\n      20% { transform: rotateZ(10deg); animation-timing-function: ease-out; }\n      40% { transform: rotateZ(17deg); }\n      60% { transform: rotateZ(16deg); }\n      100% { transform: translateY(100%) rotateZ(17deg); }\n    "]);

  _templateObject36 = function _templateObject36() {
    return data;
  };

  return data;
}

function _templateObject35() {
  var data = _taggedTemplateLiteral(["\n      from { transform: translateZ(-1000px) rotateX(90deg); opacity: 0.2; }\n    "]);

  _templateObject35 = function _templateObject35() {
    return data;
  };

  return data;
}

function _templateObject34() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateZ(-1000px) rotateX(-90deg); opacity: 0.2; }\n    "]);

  _templateObject34 = function _templateObject34() {
    return data;
  };

  return data;
}

function _templateObject33() {
  var data = _taggedTemplateLiteral(["\n      from { transform: translateZ(-1000px) rotateX(-90deg); opacity: 0.2; }\n    "]);

  _templateObject33 = function _templateObject33() {
    return data;
  };

  return data;
}

function _templateObject32() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateZ(-1000px) rotateX(90deg); opacity: 0.2; }\n    "]);

  _templateObject32 = function _templateObject32() {
    return data;
  };

  return data;
}

function _templateObject31() {
  var data = _taggedTemplateLiteral(["\n      from { transform: translateZ(-1000px) rotateY(90deg); opacity: 0.2; }\n    "]);

  _templateObject31 = function _templateObject31() {
    return data;
  };

  return data;
}

function _templateObject30() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateZ(-1000px) rotateY(-90deg); opacity: 0.2; }\n    "]);

  _templateObject30 = function _templateObject30() {
    return data;
  };

  return data;
}

function _templateObject29() {
  var data = _taggedTemplateLiteral(["\n      from { transform: translateZ(-1000px) rotateY(-90deg); opacity: 0.2; }\n    "]);

  _templateObject29 = function _templateObject29() {
    return data;
  };

  return data;
}

function _templateObject28() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateZ(-1000px) rotateY(90deg); opacity: 0.2; }\n    "]);

  _templateObject28 = function _templateObject28() {
    return data;
  };

  return data;
}

function _templateObject27() {
  var data = _taggedTemplateLiteral(["\n      0% { }\n      40% { transform: rotateX(-15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% {transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "]);

  _templateObject27 = function _templateObject27() {
    return data;
  };

  return data;
}

function _templateObject26() {
  var data = _taggedTemplateLiteral(["\n      0% { }\n      40% { transform: rotateX(15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "]);

  _templateObject26 = function _templateObject26() {
    return data;
  };

  return data;
}

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n      0% { }\n      40% { transform: rotateY(-15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n      0% { }\n      40% { transform: rotateY(15deg); opacity: 0.8; animation-timing-function: ease-out; }\n      100% { transform: scale(0.8) translateZ(-200px); opacity:0; }\n    "]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0;  transform: scale(0.7); }\n    "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: scale(0.7); }\n    "]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n\t    from { }\n\t    to { opacity: 0; transform: scale(1.2); }\n    "]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0; transform: scale(1.2); }\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n\t    from { opacity: 0;  transform: scale(0.8); }\n    "]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0; transform: scale(0.8); }\n    "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateY(100%); }\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3;  transform: translateY(100%); }\n    "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateY(-100%); }\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateY(-100%); }\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3; transform: translateX(100%); }\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3;  transform: translateX(100%); }\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      from { opacity: 0.3;  transform: translateX(-100%); }\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; transform: translateX(-100%); }\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { opacity: 0.3; }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      from { transform: translateY(100%); }\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateY(100%); }\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      from { transform: translateY(-100%); }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateY(-100%); }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      from { transform: translateX(100%); }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateX(100%); }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      from {  transform: translateX(-100%) };\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      from { }\n      to { transform: translateX(-100%); }\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { memo } from "react";
import { TransitionGroup, Transition } from "react-transition-group";
import styled, { keyframes, css } from "styled-components";

var animations = {
  moveToLeft: {
    keyframes: keyframes(_templateObject()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveFromLeft: {
    keyframes: keyframes(_templateObject2()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveToRight: {
    keyframes: keyframes(_templateObject3()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveFromRight: {
    keyframes: keyframes(_templateObject4()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveToTop: {
    keyframes: keyframes(_templateObject5()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveFromTop: {
    keyframes: keyframes(_templateObject6()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveToBottom: {
    keyframes: keyframes(_templateObject7()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveFromBottom: {
    keyframes: keyframes(_templateObject8()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  fade: {
    keyframes: keyframes(_templateObject9()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveToLeftFade: {
    keyframes: keyframes(_templateObject10()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  moveFromLeftFade: {
    keyframes: keyframes(_templateObject11()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  moveToRightFade: {
    keyframes: keyframes(_templateObject12()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  moveFromRightFade: {
    keyframes: keyframes(_templateObject13()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  moveToTopFade: {
    keyframes: keyframes(_templateObject14()),
    duration: 600,
    timing: "ease",
    fill: "both"
  },
  moveFromTopFade: {
    keyframes: keyframes(_templateObject15()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  moveToBottomFade: {
    keyframes: keyframes(_templateObject16()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  moveFromBottomFade: {
    keyframes: keyframes(_templateObject17()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  scaleDown: {
    keyframes: keyframes(_templateObject18()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  scaleUp: {
    keyframes: keyframes(_templateObject19()),
    duration: 700,
    timing: "ease",
    fill: "both"
  },
  scaleUpDown: {
    keyframes: keyframes(_templateObject20()),
    duration: 500,
    timing: "ease",
    fill: "both"
  },
  scaleDownUp: {
    keyframes: keyframes(_templateObject21()),
    duration: 500,
    timing: "ease",
    fill: "both"
  },
  scaleDownCenter: {
    keyframes: keyframes(_templateObject22()),
    duration: 400,
    timing: "ease",
    fill: "both"
  },
  scaleUpCenter: {
    keyframes: keyframes(_templateObject23()),
    duration: 400,
    timing: "ease",
    fill: "both"
  },
  rotateRightSideFirst: {
    keyframes: keyframes(_templateObject24()),
    duration: 800,
    timing: "ease-in",
    fill: "both",
    origin: "0% 50%"
  },
  rotateLeftSideFirst: {
    keyframes: keyframes(_templateObject25()),
    duration: 800,
    timing: "ease-in",
    fill: "both",
    origin: "0% 50%"
  },
  rotateTopSideFirst: {
    keyframes: keyframes(_templateObject26()),
    duration: 800,
    timing: "ease-in",
    fill: "both",
    origin: "0% 50%"
  },
  rotateBottomSideFirst: {
    keyframes: keyframes(_templateObject27()),
    duration: 800,
    timing: "ease-in",
    fill: "both",
    origin: "0% 50%"
  },
  flipOutRight: {
    keyframes: keyframes(_templateObject28()),
    duration: 500,
    timing: "ease-in",
    fill: "both",
    origin: "50% 50%"
  },
  flipInLeft: {
    keyframes: keyframes(_templateObject29()),
    duration: 500,
    timing: "ease-out",
    fill: "both",
    origin: "50% 50%"
  },
  flipOutLeft: {
    keyframes: keyframes(_templateObject30()),
    duration: 500,
    timing: "ease-in",
    fill: "both",
    origin: "50% 50%"
  },
  flipInRight: {
    keyframes: keyframes(_templateObject31()),
    duration: 500,
    timing: "ease-out",
    fill: "both",
    origin: "50% 50%"
  },
  flipOutTop: {
    keyframes: keyframes(_templateObject32()),
    duration: 500,
    timing: "ease-in",
    fill: "both",
    origin: "50% 50%"
  },
  flipInBottom: {
    keyframes: keyframes(_templateObject33()),
    duration: 500,
    timing: "ease-out",
    fill: "both",
    origin: "50% 50%"
  },
  flipOutBottom: {
    keyframes: keyframes(_templateObject34()),
    duration: 500,
    timing: "ease-in",
    fill: "both",
    origin: "50% 50%"
  },
  flipInTop: {
    keyframes: keyframes(_templateObject35()),
    duration: 500,
    timing: "ease-out",
    fill: "both",
    origin: "50% 50%"
  },
  rotateFall: {
    keyframes: keyframes(_templateObject36()),
    duration: 1e3,
    timing: "ease-in",
    fill: "both",
    origin: "0% 0%"
  },
  rotateOutNewspaper: {
    keyframes: keyframes(_templateObject37()),
    duration: 500,
    timing: "ease-in",
    fill: "both",
    origin: "50% 50%"
  },
  rotateInNewspaper: {
    keyframes: keyframes(_templateObject38()),
    duration: 500,
    timing: "ease-out",
    fill: "both",
    origin: "50% 50%"
  },
  rotatePushLeft: {
    keyframes: keyframes(_templateObject39()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "0% 50%"
  },
  rotatePushRight: {
    keyframes: keyframes(_templateObject40()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "100% 50%"
  },
  rotatePushTop: {
    keyframes: keyframes(_templateObject41()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 0%"
  },
  rotatePushBottom: {
    keyframes: keyframes(_templateObject42()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 100%"
  },
  rotatePullRight: {
    keyframes: keyframes(_templateObject43()),
    duration: 500,
    timing: "ease",
    fill: "both",
    origin: "100% 50%"
  },
  rotatePullLeft: {
    keyframes: keyframes(_templateObject44()),
    duration: 500,
    timing: "ease",
    fill: "both",
    origin: "0% 50%"
  },
  rotatePullTop: {
    keyframes: keyframes(_templateObject45()),
    duration: 500,
    timing: "ease",
    fill: "both",
    origin: "50% 0%"
  },
  rotatePullBottom: {
    keyframes: keyframes(_templateObject46()),
    duration: 500,
    timing: "ease",
    fill: "both",
    origin: "50% 100%"
  },
  rotateFoldRight: {
    keyframes: keyframes(_templateObject47()),
    duration: 700,
    timing: "ease",
    fill: "both",
    origin: "0% 50%"
  },
  rotateFoldLeft: {
    keyframes: keyframes(_templateObject48()),
    duration: 700,
    timing: "ease",
    fill: "both",
    origin: "100% 50%"
  },
  rotateFoldTop: {
    keyframes: keyframes(_templateObject49()),
    duration: 700,
    timing: "ease",
    fill: "both",
    origin: "50% 100%"
  },
  rotateFoldBottom: {
    keyframes: keyframes(_templateObject50()),
    duration: 700,
    timing: "ease",
    fill: "both",
    origin: "50% 0%"
  },
  rotateUnfoldLeft: {
    keyframes: keyframes(_templateObject51()),
    duration: 700,
    timing: "ease",
    fill: "both",
    origin: "100% 50%"
  },
  rotateUnfoldRight: {
    keyframes: keyframes(_templateObject52()),
    duration: 700,
    timing: "ease",
    fill: "both",
    origin: "0% 50%"
  },
  rotateUnfoldTop: {
    keyframes: keyframes(_templateObject53()),
    duration: 700,
    timing: "ease",
    fill: "both",
    origin: "50% 100%"
  },
  rotateUnfoldBottom: {
    keyframes: keyframes(_templateObject54()),
    duration: 700,
    timing: "ease",
    fill: "both",
    origin: "50% 0%"
  },
  rotateRoomLeftOut: {
    keyframes: keyframes(_templateObject55()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "100% 50%"
  },
  rotateRoomLeftIn: {
    keyframes: keyframes(_templateObject56()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "0% 50%"
  },
  rotateRoomRightOut: {
    keyframes: keyframes(_templateObject57()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "0% 50%"
  },
  rotateRoomRightIn: {
    keyframes: keyframes(_templateObject58()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "100% 50%"
  },
  rotateRoomTopOut: {
    keyframes: keyframes(_templateObject59()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 100%"
  },
  rotateRoomTopIn: {
    keyframes: keyframes(_templateObject60()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 0%"
  },
  rotateRoomBottomOut: {
    keyframes: keyframes(_templateObject61()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 0%"
  },
  rotateRoomBottomIn: {
    keyframes: keyframes(_templateObject62()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 100%"
  },
  rotateCubeLeftOut: {
    keyframes: keyframes(_templateObject63()),
    duration: 600,
    timing: "ease-in",
    fill: "both",
    origin: "100% 50%"
  },
  rotateCubeLeftIn: {
    keyframes: keyframes(_templateObject64()),
    duration: 600,
    timing: "ease-in",
    fill: "both",
    origin: "0% 50%"
  },
  rotateCubeRightOut: {
    keyframes: keyframes(_templateObject65()),
    duration: 600,
    timing: "ease-in",
    fill: "both",
    origin: "0% 50%"
  },
  rotateCubeRightIn: {
    keyframes: keyframes(_templateObject66()),
    duration: 600,
    timing: "ease-in",
    fill: "both",
    origin: "100% 50%"
  },
  rotateCubeTopOut: {
    keyframes: keyframes(_templateObject67()),
    duration: 600,
    timing: "ease-in",
    fill: "both",
    origin: "50% 100%"
  },
  rotateCubeTopIn: {
    keyframes: keyframes(_templateObject68()),
    duration: 600,
    timing: "ease-in",
    fill: "both",
    origin: "50% 0%"
  },
  rotateCubeBottomOut: {
    keyframes: keyframes(_templateObject69()),
    duration: 600,
    timing: "ease-in",
    fill: "both",
    origin: "50% 0%"
  },
  rotateCubeBottomIn: {
    keyframes: keyframes(_templateObject70()),
    duration: 600,
    timing: "ease-in",
    fill: "both",
    origin: "50% 100%"
  },
  rotateCarouselLeftOut: {
    keyframes: keyframes(_templateObject71()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "100% 50%"
  },
  rotateCarouselLeftIn: {
    keyframes: keyframes(_templateObject72()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "0% 50%"
  },
  rotateCarouselRightOut: {
    keyframes: keyframes(_templateObject73()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "0% 50%"
  },
  rotateCarouselRightIn: {
    keyframes: keyframes(_templateObject74()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "100% 50%"
  },
  rotateCarouselTopOut: {
    keyframes: keyframes(_templateObject75()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 100%"
  },
  rotateCarouselTopIn: {
    keyframes: keyframes(_templateObject76()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 0%"
  },
  rotateCarouselBottomOut: {
    keyframes: keyframes(_templateObject77()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 0%"
  },
  rotateCarouselBottomIn: {
    keyframes: keyframes(_templateObject78()),
    duration: 800,
    timing: "ease",
    fill: "both",
    origin: "50% 100%"
  },
  rotateSidesOut: {
    keyframes: keyframes(_templateObject79()),
    duration: 500,
    timing: "ease-in",
    fill: "both",
    origin: "-50% 50%"
  },
  rotateSidesIn: {
    keyframes: keyframes(_templateObject80()),
    duration: 500,
    timing: "ease-in",
    fill: "both",
    origin: "150% 50%"
  },
  rotateSlideOut: {
    keyframes: keyframes(_templateObject81()),
    duration: 1e3,
    timing: "ease",
    fill: "both"
  },
  rotateSlideIn: {
    keyframes: keyframes(_templateObject82()),
    duration: 1e3,
    timing: "ease",
    fill: "both"
  }
},
    presets = {
  moveToLeftFromRight: {
    exit: {
      name: "moveToLeft"
    },
    enter: {
      name: "moveFromRight"
    }
  },
  moveToRightFromLeft: {
    exit: {
      name: "moveToRight"
    },
    enter: {
      name: "moveFromLeft"
    }
  },
  moveToTopFromBottom: {
    exit: {
      name: "moveToTop"
    },
    enter: {
      name: "moveFromBottom"
    }
  },
  moveToBottomFromTop: {
    exit: {
      name: "moveToBottom"
    },
    enter: {
      name: "moveFromTop"
    }
  },
  fadeFromRight: {
    exit: {
      name: "fade"
    },
    enter: {
      name: "moveFromRight",
      onTop: !0
    }
  },
  fadeFromLeft: {
    exit: {
      name: "fade"
    },
    enter: {
      name: "moveFromLeft",
      onTop: !0
    }
  },
  fadeFromBottom: {
    exit: {
      name: "fade"
    },
    enter: {
      name: "moveFromBottom",
      onTop: !0
    }
  },
  fadeFromTop: {
    exit: {
      name: "fade"
    },
    enter: {
      name: "moveFromTop",
      onTop: !0
    }
  },
  fadeLeftFadeRight: {
    exit: {
      name: "moveToLeftFade"
    },
    enter: {
      name: "moveFromRightFade"
    }
  },
  fadeRightFadeLeft: {
    exit: {
      name: "moveToRightFade"
    },
    enter: {
      name: "moveFromLeftFade"
    }
  },
  fadeTopFadeBottom: {
    exit: {
      name: "moveToTopFade"
    },
    enter: {
      name: "moveFromBottomFade"
    }
  },
  fadeBottomFadeTop: {
    exit: {
      name: "moveToBottomFade"
    },
    enter: {
      name: "moveFromTopFade"
    }
  },
  scaleDownFromRight: {
    exit: {
      name: "scaleDown"
    },
    enter: {
      name: "moveFromRight",
      onTop: !0
    }
  },
  scaleDownFromLeft: {
    exit: {
      name: "scaleDown"
    },
    enter: {
      name: "moveFromLeft",
      onTop: !0
    }
  },
  scaleDownFromBottom: {
    exit: {
      name: "scaleDown"
    },
    enter: {
      name: "moveFromBottom",
      onTop: !0
    }
  },
  scaleDownFromTop: {
    exit: {
      name: "scaleDown"
    },
    enter: {
      name: "moveFromTop",
      onTop: !0
    }
  },
  scaleDownScaleDown: {
    exit: {
      name: "scaleDown"
    },
    enter: {
      name: "scaleUpDown",
      delay: 300
    }
  },
  scaleUpScaleUp: {
    exit: {
      name: "scaleDownUp"
    },
    enter: {
      name: "scaleUp",
      delay: 300
    }
  },
  moveToLeftScaleUp: {
    exit: {
      name: "moveToLeft",
      onTop: !0
    },
    enter: {
      name: "scaleUp"
    }
  },
  moveToRightScaleUp: {
    exit: {
      name: "moveToRight",
      onTop: !0
    },
    enter: {
      name: "scaleUp"
    }
  },
  moveToTopScaleUp: {
    exit: {
      name: "moveToTop",
      onTop: !0
    },
    enter: {
      name: "scaleUp"
    }
  },
  moveToBottomScaleUp: {
    exit: {
      name: "moveToBottom",
      onTop: !0
    },
    enter: {
      name: "scaleUp"
    }
  },
  scaleDownScaleUp: {
    exit: {
      name: "scaleDownCenter"
    },
    enter: {
      name: "scaleUpCenter",
      delay: 400
    }
  },
  glueLeftFromRight: {
    exit: {
      name: "rotateRightSideFirst"
    },
    enter: {
      name: "moveFromRight",
      delay: 200,
      onTop: !0
    }
  },
  glueRightFromLeft: {
    exit: {
      name: "rotateLeftSideFirst"
    },
    enter: {
      name: "moveFromLeft",
      delay: 200,
      onTop: !0
    }
  },
  glueBottomFromTop: {
    exit: {
      name: "rotateTopSideFirst"
    },
    enter: {
      name: "moveFromTop",
      delay: 200,
      onTop: !0
    }
  },
  glueTopFromBottom: {
    exit: {
      name: "rotateBottomSideFirst"
    },
    enter: {
      name: "moveFromBottom",
      delay: 200,
      onTop: !0
    }
  },
  flipRight: {
    exit: {
      name: "flipOutRight"
    },
    enter: {
      name: "flipInLeft",
      delay: 500
    }
  },
  flipLeft: {
    exit: {
      name: "flipOutLeft"
    },
    enter: {
      name: "flipInRight",
      delay: 500
    }
  },
  flipTop: {
    exit: {
      name: "flipOutTop"
    },
    enter: {
      name: "flipInBottom",
      delay: 500
    }
  },
  flipBottom: {
    exit: {
      name: "flipOutBottom"
    },
    enter: {
      name: "flipInTop",
      delay: 500
    }
  },
  fall: {
    exit: {
      name: "rotateFall",
      onTop: !0
    },
    enter: {
      name: "scaleUp"
    }
  },
  newspaper: {
    exit: {
      name: "rotateOutNewspaper"
    },
    enter: {
      name: "rotateInNewspaper",
      delay: 500
    }
  },
  pushLeftFromRight: {
    exit: {
      name: "rotatePushLeft"
    },
    enter: {
      name: "moveFromRight"
    }
  },
  pushRightFromLeft: {
    exit: {
      name: "rotatePushRight"
    },
    enter: {
      name: "moveFromLeft"
    }
  },
  pushTopFromBottom: {
    exit: {
      name: "rotatePushTop"
    },
    enter: {
      name: "moveFromBottom"
    }
  },
  pushBottomFromTop: {
    exit: {
      name: "rotatePushBottom"
    },
    enter: {
      name: "moveFromTop"
    }
  },
  pushLeftPullRight: {
    exit: {
      name: "rotatePushLeft"
    },
    enter: {
      name: "rotatePullRight",
      delay: 180
    }
  },
  pushRightPullLeft: {
    exit: {
      name: "rotatePushRight"
    },
    enter: {
      name: "rotatePullLeft",
      delay: 180
    }
  },
  pushTopPullBottom: {
    exit: {
      name: "rotatePushTop"
    },
    enter: {
      name: "rotatePullBottom",
      delay: 180
    }
  },
  pushBottomPullTop: {
    exit: {
      name: "rotatePushBottom"
    },
    enter: {
      name: "rotatePullTop",
      delay: 180
    }
  },
  foldLeftFromRight: {
    exit: {
      name: "rotateFoldLeft"
    },
    enter: {
      name: "moveFromRightFade"
    }
  },
  foldRightFromLeft: {
    exit: {
      name: "rotateFoldRight"
    },
    enter: {
      name: "moveFromLeftFade"
    }
  },
  foldTopFromBottom: {
    exit: {
      name: "rotateFoldTop"
    },
    enter: {
      name: "moveFromBottomFade"
    }
  },
  foldBottomFromTop: {
    exit: {
      name: "rotateFoldBottom"
    },
    enter: {
      name: "moveFromTopFade"
    }
  },
  moveToRightUnfoldLeft: {
    exit: {
      name: "moveToRightFade"
    },
    enter: {
      name: "rotateUnfoldLeft"
    }
  },
  moveToLeftUnfoldRight: {
    exit: {
      name: "moveToLeftFade"
    },
    enter: {
      name: "rotateUnfoldRight"
    }
  },
  moveToBottomUnfoldTop: {
    exit: {
      name: "moveToBottomFade"
    },
    enter: {
      name: "rotateUnfoldTop"
    }
  },
  moveToTopUnfoldBottom: {
    exit: {
      name: "moveToTopFade"
    },
    enter: {
      name: "rotateUnfoldBottom"
    }
  },
  roomToLeft: {
    exit: {
      name: "rotateRoomLeftOut",
      onTop: !0
    },
    enter: {
      name: "rotateRoomLeftIn"
    }
  },
  roomToRight: {
    exit: {
      name: "rotateRoomRightOut",
      onTop: !0
    },
    enter: {
      name: "rotateRoomRightIn"
    }
  },
  roomToTop: {
    exit: {
      name: "rotateRoomTopOut",
      onTop: !0
    },
    enter: {
      name: "rotateRoomTopIn"
    }
  },
  roomToBottom: {
    exit: {
      name: "rotateRoomBottomOut",
      onTop: !0
    },
    enter: {
      name: "rotateRoomBottomIn"
    }
  },
  cubeToLeft: {
    exit: {
      name: "rotateCubeLeftOut",
      onTop: !0
    },
    enter: {
      name: "rotateCubeLeftIn"
    }
  },
  cubeToRight: {
    exit: {
      name: "rotateCubeRightOut",
      onTop: !0
    },
    enter: {
      name: "rotateCubeRightIn"
    }
  },
  cubeToTop: {
    exit: {
      name: "rotateCubeTopOut",
      onTop: !0
    },
    enter: {
      name: "rotateCubeTopIn"
    }
  },
  cubeToBottom: {
    exit: {
      name: "rotateCubeBottomOut",
      onTop: !0
    },
    enter: {
      name: "rotateCubeBottomIn"
    }
  },
  carouselToLeft: {
    exit: {
      name: "rotateCarouselLeftOut",
      onTop: !0
    },
    enter: {
      name: "rotateCarouselLeftIn"
    }
  },
  carouselToRight: {
    exit: {
      name: "rotateCarouselRightOut",
      onTop: !0
    },
    enter: {
      name: "rotateCarouselRightIn"
    }
  },
  carouselToTop: {
    exit: {
      name: "rotateCarouselTopOut",
      onTop: !0
    },
    enter: {
      name: "rotateCarouselTopIn"
    }
  },
  carouselToBottom: {
    exit: {
      name: "rotateCarouselBottomOut",
      onTop: !0
    },
    enter: {
      name: "rotateCarouselBottomIn"
    }
  },
  slides: {
    exit: {
      name: "rotateSidesOut"
    },
    enter: {
      name: "rotateSidesIn",
      delay: 200
    }
  },
  slide: {
    exit: {
      name: "rotateSlideOut"
    },
    enter: {
      name: "rotateSlideIn"
    }
  }
},
    createAnimationStyles = function createAnimationStyles(_ref) {
  var a = _ref.keyframes,
      b = _ref.delay,
      c = _ref.duration,
      d = _ref.timing,
      e = _ref.fill,
      f = _ref.origin,
      g = _ref.onTop;
  return css(_templateObject83(), a, b, c, d, e, f || "50% 50%", g && css(_templateObject84()));
},
    stateMap = {
  entering: function entering(_ref2) {
    var a = _ref2.enterAnimation;
    return css(_templateObject85(), createAnimationStyles(a));
  },
  exiting: function exiting(_ref3) {
    var a = _ref3.exitAnimation;
    return css(_templateObject86(), createAnimationStyles(a));
  }
},
    PageTransitionGroup = styled.div(_templateObject87()),
    PageTransitionWrapper = styled.div(_templateObject88(), function (_ref4) {
  var a = _ref4.state;
  return stateMap[a];
});

function PageTransition(_ref5) {
  var a = _ref5.children,
      b = _ref5.enterAnimation,
      c = _ref5.exitAnimation,
      d = _ref5.preset,
      e = _ref5.transitionKey,
      f = _objectWithoutProperties(_ref5, ["children", "enterAnimation", "exitAnimation", "preset", "transitionKey"]);

  var g = function () {
    return b ? "string" == typeof b ? animations[b] : _objectSpread(_objectSpread({}, animations[b.name]), {}, {
      delay: b.delay,
      onTop: b.onTop
    }) : d ? _objectSpread(_objectSpread({}, animations[presets[d].enter.name]), {}, {
      delay: presets[d].enter.delay,
      onTop: presets[d].enter.onTop
    }) : "rotateSlideIn";
  }(),
      h = function () {
    return c ? "string" == typeof c ? animations[c] : _objectSpread(_objectSpread({}, animations[c.name]), {}, {
      delay: c.delay,
      onTop: c.onTop
    }) : d ? _objectSpread(_objectSpread({}, animations[presets[d].exit.name]), {}, {
      delay: presets[d].exit.delay,
      onTop: presets[d].exit.onTop
    }) : "rotateSlideIn";
  }(),
      i = Math.max(g.duration, h.duration);

  return /*#__PURE__*/React.createElement(PageTransitionGroup, f, /*#__PURE__*/React.createElement(TransitionGroup, {
    component: null
  }, /*#__PURE__*/React.createElement(Transition, {
    key: e,
    timeout: i
  }, function (b) {
    return /*#__PURE__*/React.createElement(PageTransitionWrapper, {
      enterAnimation: g,
      exitAnimation: h,
      state: b
    }, a);
  })));
}

var PageTransition$1 = /*#__PURE__*/memo(PageTransition);
export { PageTransition$1 as PageTransition, animations, presets };